import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import reportApiController from "../../services/report.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";

export const usersAdapter = createEntityAdapter();

export const ReportListViewApi = createAsyncThunk("report/listview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await reportApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "listview"))
      .catch((error) => HandleError(thunkAPI, error, "listview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const PrintoutApi = createAsyncThunk("report/Printout", async (formValues, thunkAPI) => {
  try {
    const resposedata = await reportApiController
      .printout(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "Printout"))
      .catch((error) => HandleError(thunkAPI, error, "Printout"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const clientByProductMoreProductApi = createAsyncThunk("report/moreproducts", async (formValues, thunkAPI) => {
  try {
    const resposedata = await reportApiController
      .moreclientbyproducts(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "moreproducts"))
      .catch((error) => HandleError(thunkAPI, error, "moreproducts"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  isListView: [],
  isOpenListModal: "",
  isScreenReport: "",
  isStaffFilter: "",
  isSupplierFilter: "",
  isServiceFilter: "",
  isProductFilter: "",
  isPrintFromApi: "",
  isSaleByProductSort:"",
  isClientByProductMoreProduct : [],
  isApiStatus: {
    ReportListViewApi: "",
    PrintoutApi: "",
    clientByProductMoreProductApi:""
  },
};

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    reset: () => initialState,
    OpenListModal: (state = initialState, action) => {
      state.isOpenListModal = action.payload;
    },
    ScreenReport: (state, action) => {
      state.isScreenReport = action.payload;
    },
    StaffFilter: (state, action) => {
      state.isStaffFilter = action.payload;
    },
    ResetStaffFilter: (state) => {
      state.isStaffFilter = "";
    },
    SupplierFilter: (state, action) => {
      state.isSupplierFilter = action.payload;
    },
    ResetSupplierFilter: (state) => {
      state.isSupplierFilter = "";
    },
    ServiceFilter: (state, action) => {
      state.isServiceFilter = action.payload;
    },
    ResetServiceFilter: (state) => {
      state.isServiceFilter = "";
    },
    ProductFilter: (state, action) => {
      state.isProductFilter = action.payload;
    },
    ResetProductFilter: (state) => {
      state.isProductFilter = "";
    },
    PrintContent: (state, action) => {
      state.isPrint = action.payload;
    },
    PrintContentFromApi: (state, action) => {
      state.isPrintFromApi = action.payload;
    },
    SaleByProductSort: (state, action) => {
      state.isSaleByProductSort = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(ReportListViewApi.pending, (state) => {
      state.isApiStatus.ReportListViewApi = 'loading';
    })
    .addCase(ReportListViewApi.fulfilled, (state, action) => {
      let old_current_page = state.isListView.current_page ? state.isListView.current_page : "";
      let new_current_page = action.payload.current_page ? action.payload.current_page : "";
      let viewdata = state.isListView && state.isListView.data;
      let newviewdata = action.payload && action.payload.data;
      state.isListView = action.payload;
      if (old_current_page && new_current_page && old_current_page < new_current_page && old_current_page != new_current_page) {
        viewdata && newviewdata ? (state.isListView.data = [...viewdata, ...newviewdata]) : action.payload;
      }
      state.isApiStatus.ReportListViewApi = 'succeeded';
    })
    .addCase(ReportListViewApi.rejected, (state) => {
      state.isListView = [];
      state.isApiStatus.ReportListViewApi = 'failed';
    })
    .addCase(PrintoutApi.pending, (state) => {
      state.isApiStatus.PrintoutApi = 'loading';
    })
    .addCase(PrintoutApi.fulfilled, (state, action) => {
      state.isPrint = action.payload;
      state.isApiStatus.PrintoutApi = 'succeeded';
    })
    .addCase(PrintoutApi.rejected, (state) => {
      state.isPrint = "";
      state.isApiStatus.PrintoutApi = 'failed';
    })
    .addCase(clientByProductMoreProductApi.pending, (state) => {
      state.isApiStatus.clientByProductMoreProductApi = 'loading';
    })
    .addCase(clientByProductMoreProductApi.fulfilled, (state, action) => {
      state.isClientByProductMoreProduct = action.payload;
      state.isApiStatus.clientByProductMoreProductApi = 'succeeded';
    })
    .addCase(clientByProductMoreProductApi.rejected, (state) => {
      state.isClientByProductMoreProduct = [];
      state.isApiStatus.clientByProductMoreProductApi = 'failed';
    });
  },
});
// Action creators are generated for each case reducer function
export const { reset, OpenListModal, ScreenReport, StaffFilter, ResetStaffFilter, SupplierFilter, ResetSupplierFilter, ServiceFilter, ResetServiceFilter, ProductFilter, ResetProductFilter, PrintContent,PrintContentFromApi,SaleByProductSort } = reportSlice.actions;
export default reportSlice.reducer;
